import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=6f37b638&scoped=true&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"
import style1 from "./Dashboard.vue?vue&type=style&index=1&id=6f37b638&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f37b638",
  null
  
)

export default component.exports